import {
  useQuery,
} from 'react-query';

import { useMiddleman } from '@hubins/middleman';

export const useWithdrawalAccounts = (portfolioUuid) => {
  const middleman = useMiddleman();

  return useQuery(['withdrawal_accounts', portfolioUuid], () => {
    return middleman.get(`/ql/crm/withdrawal-accounts/${portfolioUuid}`);
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};

export const useWithdrawalAccountHistory = (withdrawalAccountUuid, enabled = false) => {
  const middleman = useMiddleman();

  return useQuery(['withdrawal_account_history', withdrawalAccountUuid], () => {
    return middleman.promiseGet(`/ql/crm/withdrawal-accounts/${withdrawalAccountUuid}/history`).then(res => res.data);
  }, {
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    enabled,
  });
};